import { mapProps } from 'recompose'
import { FormattedRelativeTime } from 'react-intl'
// import moment from 'moment'
import { selectUnit } from '@formatjs/intl-utils'

export default mapProps(({ from, to }) => selectUnit(from, to))(
  FormattedRelativeTime
)
